import { isTestBlocked } from "../constants/testCatalog";

/**
 * In-memory session for the Corregir Test landing component.
 * Mirrors ChatbotTestCorrection.context.correctedTests without chat state.
 *
 * `granel`: la sesión arma un informe integrado por profesión (el producto
 * suelto). Dentro del colegio va en false: ahí la sesión se siembra con el
 * historial del estudiante y cada informe toma sus tests del tipo de
 * documento, así que los tests standalone no tienen por qué bloquear nada.
 */
export function createTestCorrectionSession({ granel = true } = {}) {
  return {
    granel,
    correctedTests: [],
    downloadedTestIds: [],

    getCorrection(testValue) {
      return this.correctedTests.find((entry) => entry.test === testValue) || null;
    },

    isCorrected(testValue) {
      return !!this.getCorrection(testValue);
    },

    isBlocked(testValue) {
      return isTestBlocked(testValue, this.correctedTests, { granel: this.granel });
    },

    upsertCorrection({ id, test, name }) {
      const entry = { id: id || null, test, name };
      const idx = this.correctedTests.findIndex((item) => item.test === test);
      if (idx >= 0) {
        this.correctedTests.splice(idx, 1, entry);
      } else {
        this.correctedTests.push(entry);
      }
      return entry;
    },

    removeCorrection(testValue) {
      const idx = this.correctedTests.findIndex((item) => item.test === testValue);
      if (idx >= 0) this.correctedTests.splice(idx, 1);
    },

    markDownloaded(testId) {
      if (!testId || this.downloadedTestIds.includes(testId)) return;
      this.downloadedTestIds.push(testId);
    },

    isDownloaded(testId) {
      return this.downloadedTestIds.includes(testId);
    },

    reset() {
      this.correctedTests = [];
      this.downloadedTestIds = [];
    },
  };
}
